var g2 = "/static/f5ccc8e2d027f35c.png";

export { g2 as default };
//# sourceMappingURL=g_2.png.js.map
